<template>
  <div>
    <h2>Visualizar Tokens </h2>
    <v-card>
      <v-container fluid>
        <v-card class="mb-2">
          <v-card-title>
            Filtros
          </v-card-title>
          <v-card-text>
            <v-row align="center">
              <v-col
                  class="d-flex"
                  cols="4"
                  sm="4"
              >
                <v-select
                    v-model="search.lote_id"
                    :items="lotes"
                    label="Lote"
                    item-value="lote"
                    item-text="lote"
                    single-line
                    hide-details
                    clearable
                ></v-select>
              </v-col>

              <v-col
                  class="d-flex"
                  cols="4"
                  sm="4"
              >
                <v-select
                    v-model="search.document_id"
                    :items="documents"
                    label="Documento"
                    item-value="id"
                    item-text="name_registration"
                    single-line
                    hide-details
                    clearable
                ></v-select>
              </v-col>

              <v-col
                  class="d-flex"
                  cols="4"
                  sm="4"
              >
                <v-autocomplete
                    v-model="search.user_id"
                    :items="users"
                    item-value="id"
                    item-text="name"
                    label="Usuarios"
                    single-line
                    hide-details
                    clearable
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                  class="d-flex"
                  cols="4"
                  sm="4"
              >
                <v-select
                    v-model="search.view"
                    :items="item"
                    item-value="id"
                    item-text="name"
                    single-line
                    hide-details
                ></v-select>
              </v-col>
              <v-col class="d-flex" cols="8" sm="8">
                  <v-text-field
                      v-model="search.interval.start"
                      label="Visualizar início em (inicia em 0)"
                      single-line
                      hide-details
                      clearable
                  ></v-text-field>
                  <v-text-field
                      v-model="search.interval.end"
                      label="Visualizar até"
                      class="pl-4"
                      single-line
                      hide-details
                      clearable
                  ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-card-actions>
                <v-btn
                    color="teal darken-3"
                    text
                    @click="loadData()"
                >
                  Clique para Filtrar
                </v-btn>
              </v-card-actions>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>

      <v-container>
        <v-card v-if="data.length">
          <ul id="tokens2" class="justify-center py-6">
            <li v-for="(token, index) in data" :key="index">
              <v-btn
                  v-bind:color="
                  token.certificate_id
                    ? 'success'
                    : token.user_id
                    ? 'yellow'
                    : 'gray'
                "
                  @click="details(token.id)"
              >
                {{ token.name }}
              </v-btn>
            </li>
          </ul>
        </v-card>
      </v-container>
    </v-card>

    <div v-if="totalPages" class="text-center">
      <v-container>
        <v-row justify="center">
          <v-col cols="8">
            <v-container class="max-width">
              <v-pagination
                  v-model="page"
                  class="my-4"
                  :length="totalPages"
              ></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <v-dialog v-model="dialogGenerate" max-width="540px" v-if="!isLoading">
      <v-card>
        <div>
          <v-card-title class="headline center">Visualizar Tokens</v-card-title>
          <v-card-text>
            <v-container>
              <v-slide-group show-arrows>
                <v-slide-item v-for="n in lotes" :key="n.lote" v-slot="{ active, toggle }">
                  <v-btn
                      class="mx-2"
                      :input-value="active"
                      active-class="success white--text"
                      depressed
                      @click="toggle"
                      v-on:click="setLote(n)"
                  >
                    Lote {{ n.lote }}
                  </v-btn>
                </v-slide-item>
              </v-slide-group>
            </v-container>
          </v-card-text>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="detail" max-width="940px">
      <v-card id="tokensdetails">
        <v-card-title class="headline center">
          <v-row>
            <v-col cols="3" sm="3" md="3">
              <p>Token</p>
              <p style="color : gray">{{ tokenEspecific[0] ? tokenEspecific[0].name : "-" }}</p>
            </v-col>
            <v-col cols="3" sm="3" md="3">
              <p>Matricula</p>

              <p style="color : gray">
                {{
                  tokenEspecific[1] ? tokenEspecific[1].name_registration : "-"
                }}
              </p>
            </v-col>
            <v-col cols="3" sm="3" md="3">
              <p>Lote</p>

              <p style="color : gray">{{ tokenEspecific[0] ? tokenEspecific[0].lote : "-" }}</p>
            </v-col>
            <v-col cols="3" sm="3" md="3">
              <p>Ativo</p>
              <p style="color : gray">
                {{ tokenEspecific[0] ? tokenEspecific[0].name_token : "-" }}
              </p>
            </v-col>
          </v-row>
        </v-card-title>

        <v-container>
          <v-row v-if="tokenEspecific[1] && tokenEspecific[1].name">
            <v-col cols="12">
              Propriedade de {{ tokenEspecific[1].name }}
            </v-col>
          </v-row>
          <v-row v-if="tokenEspecific[1] && tokenEspecific[1].created_at">
            <v-col cols="12">
              Data de emissão certificado:
              {{ formatDate(tokenEspecific[1].created_at) }}
            </v-col>
          </v-row>
          <v-row v-if="tokenEspecific[1] && tokenEspecific[0].blockchain_id">
            <v-col cols="12">
              Código do token na blockchain: {{ tokenEspecific[0].blockchain_id }}
            </v-col>
          </v-row>
          <v-row v-if="tokenEspecific[1] && tokenEspecific[1].certificate_blockchain_id">
            <v-col cols="12">
              Código do certificado na blockchain: {{ tokenEspecific[1].certificate_blockchain_id }}
            </v-col>
          </v-row>
          <v-row v-if="tokenEspecific[1] && tokenEspecific[1].certificate_blockchain_id">
            <v-col cols="12">
              Certificado na blockchain: {{ tokenEspecific[1].certificate_blockchain_id }}
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions v-if="isLoadingGenerate">
          <v-spacer></v-spacer>
          <v-btn color="#0dc4b8" text @click="closeDetailsModal">Fechar</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <div>
      <v-overlay
          :value="isLoading"
      >
        <v-progress-circular
            :indeterminate="isLoading"
            size="90"
        >
          Loading...
        </v-progress-circular>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import Api from "../../services/api.service";
import moment from "moment";

export default {
  name: "showToken",
  props: {
    code: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
    isLoadingGenerate: true,
    data: [],
    filteredTokens: [],
    users: [],
    lotes: [],
    documents: [],
    params: {},
    item: [{id: "all", name: "Ver Todos"}, {id: "certificate", name: "Certificados"},
      {id: "emited", name: "Emitidos"}, {id: "free", name: "A emitir"}],
    detail: false,
    search: {
      assets_id: null,
      lote_id: null,
      document_id: null,
      user_id: null,
      view: "all",
      interval: {
        start: null,
        end: null
      }
    },
    page: 1,
    page_atual: 1,
    perPage: 171,
    sortBy: 'id',
    totalPages: 0,
    dialogGenerate: false,
    tokenEspecific: []
  }),

  watch: {
    page: function () {
      if (this.page !== this.page_atual)
        this.loadData();
    },
    searchFilter: {
      handler() {
        this.page = 1;
        this.loadData();
      },
      deep: true,
    },
  },
  mounted() {
    this.loadFilter();
  },

  methods: {
    openModal() {
      this.dialogGenerate = true;
      this.overlay = false;
    },

    closeDetailsModal() {
      this.detail = false;
    },

    setLote(n) {
      this.search.lote_id = n.lote;
      this.search.document_id = this.getFor(this.documents)
      this.loadData();
    },

    getFor(value) {
      let res = null;
      for (const val of value){
        res = val;
      }
      return res
    },

    loadData() {
      this.dialogGenerate = false;
      this.isLoading = true;

      const params = {
        page: this.page,
        perPage: this.perPage,
        sort: this.sortBy,
        search: {}
      }

      if (this.code) {
        Object.assign(params.search, {assets_id: parseInt(this.code)});
      }
      if (this.search.lote_id) {
        Object.assign(params.search, {lote_id: this.search.lote_id});
      }
      if (this.search.document_id) {
        Object.assign(params.search, {document_id: this.search.document_id});
      }
      if (this.search.user_id) {
        Object.assign(params.search, {user_id: this.search.user_id});
      }
      if (this.search.interval.start && this.search.interval.end) {
        Object.assign(params.search, {interval: this.search.interval});
      }
      if (this.search.view) {
        Object.assign(params.search, {view: this.search.view});
      }

      Api.post(`generation-tokens/token`, params)
          .then((res) => {
            const {data: items} = res;
            this.data = items.data;
            this.page_atual = items.current_page;
            this.total = items.total;
            this.totalPages = Math.ceil(this.total / this.perPage);
          })
          .catch(() => {
            this.showSnackbar({
              text: "Ops!, Houve um erro ao carregar as categorias, tente novamente mais tarde.",
              color: "error",
            });
          })
          .finally(() => setTimeout(() => (this.isLoading = false), 300));
    },
    
    formatDate(value) {
      return moment(value).format("DD/MM/YYYY");
    },

    loadFilter() {
      this.isLoading = true;

      Promise.all([
        Api.get(`generation-tokens/token/${this.code}`)
      ]).then((response) => {
        for (const res of response) {
          const {data: item} = res;
          this.users = item.users;
          this.lotes = item.lotes;
          this.documents = item.documents;
        }
        this.openModal();
      }).finally(() => setTimeout(() => (this.isLoading = false), 300));
    },

    details(n) {
      this.isLoading = true;
      Api.get(`token/${n}`)
          .then((res) => {
            this.tokenEspecific = res.data.token.concat(res.data.complement);
            this.detail = true;
          })
          .catch(() => {
            this.showSnackbar({
              text: "Ops!, Houve um erro ao carregar as categorias, tente novamente mais tarde.",
              color: "error",
            });
          }).finally(() => setTimeout(() => (this.isLoading = false), 300));
    },

  }
}
</script>

<style scoped>

</style>